export default "__VITE_ASSET__CsxqiKoF__"